import { LOAD_GPSSTATUS } from "./actions";

const initialState = {
  gpsstatusUrl: "",
  gpsstatusLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_GPSSTATUS.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        gpsstatusLoading: loading
      };
    case LOAD_GPSSTATUS.SUCCESS:
      return {
        ...state,
        gpsstatusUrl: action.payload.data.data,
        gpsstatusLoading: false
      };
    default:
      return state;
  }
};
